import { useEffect,useContext } from "react";
import axios from "axios";
import { baseURL } from '../axiosInterceptor/axiosInterceptorC'; // Import baseURL
import { RoleContext } from "../pages/Userdatacontext/Datacontexts";

const GetCurrentLocation = ({ setLocation, setError }) => {
  const { data, fetchpropertydetails,gettokenval } = useContext(RoleContext);
  useEffect(() => {
    if (!("geolocation" in navigator)) {
      setError("Geolocation is not supported in this browser.");
      return;
    }

    const geoOptions = {
      enableHighAccuracy: false,
      timeout: 30000,
      maximumAge: 0,
    };

    const geoSuccess = async (position) => {
      const { latitude, longitude } = position.coords;
      
      try {
        // Reverse Geocode using OpenStreetMap Nominatim API
        const response = await axios.get(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
        );

        const district =
          response.data.address.county || response.data.address.state_district || "Unknown District";
        
        setLocation(district); // Set district name

        // Call the API once district is obtained
        if (district && district !== "Unknown District") {
          const checkDistrictResponse = await axios.get(`${baseURL}/check-district`, { 
            params: { district }
          });

          localStorage.setItem("districtval", checkDistrictResponse.data[0].district_name);
          fetchpropertydetails()
          console.log("District saved:", checkDistrictResponse.data[0].district_name);
        }

      } catch (error) {
        console.error("Failed to fetch district name or check district:", error);
        setError("Failed to fetch district name.");
      }
    };

    const geoError = (error) => {
      let errorMessage = "Unknown error occurred.";
      localStorage.removeItem("districtval");
      if (error.code === 1) {
        errorMessage = "Location access denied. Please allow location permission.";
        localStorage.removeItem("districtval");
        fetchpropertydetails()
      } else if (error.code === 2) {
        errorMessage = "Location unavailable.";
        localStorage.removeItem("districtval");
        fetchpropertydetails()
      } else if (error.code === 3) {
        errorMessage = "Location request timed out.";
        localStorage.removeItem("districtval");
        fetchpropertydetails()
      }
      setError(errorMessage);
    };

    navigator.geolocation.getCurrentPosition(geoSuccess, geoError, geoOptions);
  }, [setLocation, setError]);

  return null;
};

export default GetCurrentLocation;
